import axios from 'axios';
import QS from 'qs';
import router from '../router/index'
let protocol = window.location.protocol; //协议
let host = window.location.host; //主机
axios.defaults.baseURL = protocol + "//" + host;
// 请求超时时间
axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';


/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function Post(url, param) {
    return new Promise((resolve, reject) => {
        axios({
                method: "post",
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': '5b7f2046-0067-43b0-9bd6-6897dc943000'
                },
                data: param,
            }).then(res => {
                resolve(res)
            }, err => {
                console.log('错误的传参' + err)
                reject(err)
            })
            .catch((error) => {
                console.log('错误的传参' + error)
                reject(error)
            })
    })

}

// export function post(url, params) {
//     return new Promise((resolve, reject) => {
//         axios.post(
//                 url,
//                 QS.stringify(params))
//             .then(res => {
//                 resolve(res.data);
//             })
//             .catch(err => {
//                 reject(err.data)
//             })
//     });
// }